import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';

export default class HouseCard extends Component {
    render() {
        const { imgHouse, isFirstGroup, isLastGroup, onPrevClick, onNextClick } = this.props;

        return (
            <div className='col'>
                <div className="card h-100 position-relative">
                    <img src={imgHouse} alt='House' style={{ height: "400px" }} className="card-img-top img-fluid" />
                    {isFirstGroup && (
                        <span className="badge text-dark bg-light position-absolute top-50 start-0 translate-middle-y m-3 p-3 rounded" onClick={onPrevClick}>
                            <FontAwesomeIcon icon={faAngleLeft} />
                        </span>
                    )}
                    {isLastGroup && (
                        <span className="badge text-dark bg-light position-absolute top-50 end-0 translate-middle-y m-3 p-3 rounded" onClick={onNextClick}>
                            <FontAwesomeIcon icon={faAngleRight} />
                        </span>
                    )}
                </div>
            </div >
        );
    }
}